import STORE_NAMES from "./STORE_NAMES";

export function resolveStoreName(po) {
  if (!po || !po.store) return "Unknown Store";

  // po.store is already the ObjectId
  return STORE_NAMES[String(po.store)] || "Unknown Store";
}
